import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStateContainer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "1092px",
	height: "521px",
	viewBox: "-0.5 -0.5 1092 521",
	content: "<mxfile host=\"app.diagrams.net\" modified=\"2022-06-10T06:34:03.172Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/102.0.0.0 Safari/537.36\" etag=\"KUTDh27vL_2P2pDkAOQn\" version=\"19.0.0\" type=\"google\"><diagram id=\"6a731a19-8d31-9384-78a2-239565b7b9f0\" name=\"Page-1\">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</diagram></mxfile>",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 60,
				y: 0,
				width: 500,
				height: 320,
				rx: 19.2,
				ry: 19.2,
				fill: "#d9f5ff",
				stroke: "rgb(0, 0, 0)",
				strokeDasharray: "3 3",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe flex-start",
							justifyContent: "unsafe flex-start",
							width: 1,
							height: 1,
							paddingTop: 15,
							marginLeft: 81
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #0F0F0F; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "left"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 31,
									fontFamily: "Helvetica",
									color: "rgb(15, 15, 15)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Persistent"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 81,
					y: 46,
					fill: "#0F0F0F",
					fontFamily: "Helvetica",
					fontSize: "31px",
					children: "Persistent"
				})] })
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 480,
				cy: 176.13,
				rx: 60,
				ry: 60,
				fill: "#1699d3",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 118,
							height: 1,
							paddingTop: 176,
							marginLeft: 421
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "data"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 480,
					y: 182,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "data"
				})] })
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 890,
				cy: 362.69,
				rx: 60,
				ry: 60,
				fill: "#f08705",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 118,
							height: 1,
							paddingTop: 363,
							marginLeft: 831
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "Account"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 890,
					y: 369,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Account"
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 653.13 347.74 L 522.8 218.18",
				fill: "none",
				stroke: "#1699d3",
				strokeWidth: 6,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 787.91 385.82 L 831.43 375.71",
				fill: "none",
				stroke: "#f08705",
				strokeWidth: 6,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 700.86 324.52 L 688.52 229.49",
				fill: "none",
				stroke: "#736ca8",
				strokeWidth: 6,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 390,
				y: 261.5,
				width: 130,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#64bbe2",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 282,
							marginLeft: 455
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Firstname"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 455,
					y: 288,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Firstname"
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 300,
				y: 80,
				width: 130,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#64bbe2",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 100,
							marginLeft: 365
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Lastname"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 365,
					y: 106,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Lastname"
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 420,
				y: 35,
				width: 130,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#64bbe2",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 55,
							marginLeft: 485
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Address"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 485,
					y: 61,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Address"
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 466.1 234.5 L 459.75 261.5",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 430.08 142.85 L 395.21 120",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 482.4 116.18 L 484.17 75",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 970,
				y: 261.5,
				width: 120,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#f5af58",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 282,
							marginLeft: 1030
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Avatar"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 1030,
					y: 288,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Avatar"
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 909,
				y: 170.75,
				width: 120,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#f5af58",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 191,
							marginLeft: 969
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Username"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 969,
					y: 197,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Username"
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 941.97 332.71 L 995.51 301.5",
				fill: "none",
				stroke: "#f5af58",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 914.77 308.04 L 959.81 210.75",
				fill: "none",
				stroke: "#f5af58",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 710,
				cy: 404,
				rx: 80,
				ry: 80,
				fill: "#ffffff",
				stroke: "#2f5b7c",
				strokeWidth: 6,
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 158,
							height: 1,
							paddingTop: 404,
							marginLeft: 631
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #2F5B7C; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 30,
									fontFamily: "Helvetica",
									color: "rgb(47, 91, 124)",
									lineHeight: 1.2,
									pointerEvents: "all",
									fontWeight: "bold",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "State container"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 710,
					y: 413,
					fill: "#2F5B7C",
					fontFamily: "Helvetica",
					fontSize: "30px",
					textAnchor: "middle",
					fontWeight: "bold",
					children: "State conta..."
				})] })
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 680,
				cy: 160.75,
				rx: 70,
				ry: 69.25,
				fill: "#736ca8",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 138,
							height: 1,
							paddingTop: 161,
							marginLeft: 611
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "products [array]"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 680,
					y: 167,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "products [arra..."
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 749.99 159.58 L 800.01 157.6",
				fill: "none",
				stroke: "#a29dc5",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 275,
				cy: 166.88,
				rx: 36.5,
				ry: 34.625,
				fill: "#64bbe2",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 71,
							height: 1,
							paddingTop: 167,
							marginLeft: 240
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "Pets"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 275,
					y: 173,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Pets"
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 420.04 173.99 L 311.47 168.31",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 120,
				y: 80,
				width: 130,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#afdff0",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 100,
							marginLeft: 185
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Dog"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 185,
					y: 106,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Dog"
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 230,
				y: 20,
				width: 130,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#afdff0",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 40,
							marginLeft: 295
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "Cat"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 295,
					y: 46,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Cat"
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 230,
				y: 221.5,
				width: 130,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#afdff0",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 242,
							marginLeft: 295
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 13,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: /* @__PURE__ */ _jsx("font", {
									style: { fontSize: 20 },
									children: "Fish"
								})
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 295,
					y: 245,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "13px",
					textAnchor: "middle",
					children: "Fish"
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 283.72 200.5 L 289.64 221.5",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 280.17 132.6 L 291.85 60",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 246.25 145.54 L 211.92 120",
				fill: "none",
				stroke: "#64bbe2",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 738.91 123.35 L 807 79.1",
				fill: "none",
				stroke: "#a29dc5",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 920,
				y: 11.5,
				width: 120,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#cbc8e6",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 32,
							marginLeft: 980
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "property-A"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 980,
					y: 38,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "property-A"
				})] })
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 845,
				cy: 257.69,
				rx: 45,
				ry: 45,
				fill: "#a29dc5",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 88,
							height: 1,
							paddingTop: 258,
							marginLeft: 801
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "Product 3."
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 845,
					y: 264,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Product 3."
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 740.19 196.1 L 806.16 234.96",
				fill: "none",
				stroke: "#a29dc5",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 845,
				cy: 55,
				rx: 45,
				ry: 45,
				fill: "#a29dc5",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 88,
							height: 1,
							paddingTop: 55,
							marginLeft: 801
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "Product 1."
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 845,
					y: 61,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Product 1."
				})] })
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 845,
				cy: 156.5,
				rx: 45,
				ry: 45,
				fill: "#a29dc5",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 88,
							height: 1,
							paddingTop: 157,
							marginLeft: 801
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: "Product 2."
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 845,
					y: 163,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "Product 2."
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 920,
				y: 71.5,
				width: 120,
				height: 40,
				rx: 6,
				ry: 6,
				fill: "#cbc8e6",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe center",
							width: 1,
							height: 1,
							paddingTop: 92,
							marginLeft: 980
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #FFFFFF; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "center"
							},
							children: /* @__PURE__ */ _jsx("div", {
								style: {
									display: "inline-block",
									fontSize: 20,
									fontFamily: "Helvetica",
									color: "rgb(255, 255, 255)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "nowrap"
								},
								children: "property-B"
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 980,
					y: 98,
					fill: "#FFFFFF",
					fontFamily: "Helvetica",
					fontSize: "20px",
					textAnchor: "middle",
					children: "property-B"
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 889.42 47.8 L 920 41.94",
				fill: "none",
				stroke: "#a29dc5",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 888.44 66.74 L 920 75.28",
				fill: "none",
				stroke: "#a29dc5",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 320,
				width: 320,
				height: 150,
				fill: "none",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe flex-start",
							width: 318,
							height: 1,
							paddingTop: 395,
							marginLeft: 2
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #0F0F0F; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "left"
							},
							children: /* @__PURE__ */ _jsxs("div", {
								style: {
									display: "inline-block",
									fontSize: 30,
									fontFamily: "Helvetica",
									color: "rgb(15, 15, 15)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: [
									"{",
									/* @__PURE__ */ _jsx("br", {}),
									"\xA0 \"store\":\"data\",",
									/* @__PURE__ */ _jsx("br", {}),
									"\xA0 \"path\": \"pets.Fish\"",
									/* @__PURE__ */ _jsx("br", {}),
									"}"
								]
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 2,
					y: 404,
					fill: "#0F0F0F",
					fontFamily: "Helvetica",
					fontSize: "30px",
					children: "{..."
				})] })
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 311.5,
				y: 320,
				width: 310,
				height: 200,
				fill: "none",
				stroke: "none",
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(-0.5 -0.5)",
				children: /* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("foreignObject", {
					pointerEvents: "none",
					width: "100%",
					height: "100%",
					requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
					style: {
						overflow: "visible",
						textAlign: "left"
					},
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							display: "flex",
							alignItems: "unsafe center",
							justifyContent: "unsafe flex-start",
							width: 308,
							height: 1,
							paddingTop: 420,
							marginLeft: 314
						},
						children: /* @__PURE__ */ _jsx("div", {
							"data-drawio-colors": "color: #0F0F0F; ",
							style: {
								boxSizing: "border-box",
								fontSize: 0,
								textAlign: "left"
							},
							children: /* @__PURE__ */ _jsxs("div", {
								style: {
									display: "inline-block",
									fontSize: 30,
									fontFamily: "Helvetica",
									color: "rgb(15, 15, 15)",
									lineHeight: 1.2,
									pointerEvents: "all",
									whiteSpace: "normal",
									overflowWrap: "normal"
								},
								children: [
									/* @__PURE__ */ _jsx("span", {
										style: {
											color: "rgb(15, 15, 15)",
											fontFamily: "Helvetica",
											fontSize: 30,
											fontStyle: "normal",
											fontVariantLigatures: "normal",
											fontVariantCaps: "normal",
											fontWeight: 400,
											letterSpacing: "normal",
											orphans: 2,
											textAlign: "left",
											textIndent: 0,
											textTransform: "none",
											widows: 2,
											wordSpacing: 0,
											WebkitTextStrokeWidth: 0,
											backgroundColor: "rgb(248, 249, 250)",
											textDecorationThickness: "initial",
											textDecorationStyle: "initial",
											textDecorationColor: "initial",
											float: "none",
											display: "inline !important"
										},
										children: "{"
									}),
									/* @__PURE__ */ _jsx("br", { style: {
										color: "rgb(15, 15, 15)",
										fontFamily: "Helvetica",
										fontSize: 30,
										fontStyle: "normal",
										fontVariantLigatures: "normal",
										fontVariantCaps: "normal",
										fontWeight: 400,
										letterSpacing: "normal",
										orphans: 2,
										textAlign: "left",
										textIndent: 0,
										textTransform: "none",
										widows: 2,
										wordSpacing: 0,
										WebkitTextStrokeWidth: 0,
										backgroundColor: "rgb(248, 249, 250)",
										textDecorationThickness: "initial",
										textDecorationStyle: "initial",
										textDecorationColor: "initial"
									} }),
									/* @__PURE__ */ _jsx("span", {
										style: {
											color: "rgb(15, 15, 15)",
											fontFamily: "Helvetica",
											fontSize: 30,
											fontStyle: "normal",
											fontVariantLigatures: "normal",
											fontVariantCaps: "normal",
											fontWeight: 400,
											letterSpacing: "normal",
											orphans: 2,
											textAlign: "left",
											textIndent: 0,
											textTransform: "none",
											widows: 2,
											wordSpacing: 0,
											WebkitTextStrokeWidth: 0,
											backgroundColor: "rgb(248, 249, 250)",
											textDecorationThickness: "initial",
											textDecorationStyle: "initial",
											textDecorationColor: "initial",
											float: "none",
											display: "inline !important"
										},
										children: "\xA0 \"store\":\"products\","
									}),
									/* @__PURE__ */ _jsx("br", { style: {
										color: "rgb(15, 15, 15)",
										fontFamily: "Helvetica",
										fontSize: 30,
										fontStyle: "normal",
										fontVariantLigatures: "normal",
										fontVariantCaps: "normal",
										fontWeight: 400,
										letterSpacing: "normal",
										orphans: 2,
										textAlign: "left",
										textIndent: 0,
										textTransform: "none",
										widows: 2,
										wordSpacing: 0,
										WebkitTextStrokeWidth: 0,
										backgroundColor: "rgb(248, 249, 250)",
										textDecorationThickness: "initial",
										textDecorationStyle: "initial",
										textDecorationColor: "initial"
									} }),
									/* @__PURE__ */ _jsx("span", {
										style: {
											color: "rgb(15, 15, 15)",
											fontFamily: "Helvetica",
											fontSize: 30,
											fontStyle: "normal",
											fontVariantLigatures: "normal",
											fontVariantCaps: "normal",
											fontWeight: 400,
											letterSpacing: "normal",
											orphans: 2,
											textAlign: "left",
											textIndent: 0,
											textTransform: "none",
											widows: 2,
											wordSpacing: 0,
											WebkitTextStrokeWidth: 0,
											backgroundColor: "rgb(248, 249, 250)",
											textDecorationThickness: "initial",
											textDecorationStyle: "initial",
											textDecorationColor: "initial",
											float: "none",
											display: "inline !important"
										},
										children: "\xA0 \"path\": \"0.property-A\""
									}),
									/* @__PURE__ */ _jsx("br", { style: {
										color: "rgb(15, 15, 15)",
										fontFamily: "Helvetica",
										fontSize: 30,
										fontStyle: "normal",
										fontVariantLigatures: "normal",
										fontVariantCaps: "normal",
										fontWeight: 400,
										letterSpacing: "normal",
										orphans: 2,
										textAlign: "left",
										textIndent: 0,
										textTransform: "none",
										widows: 2,
										wordSpacing: 0,
										WebkitTextStrokeWidth: 0,
										backgroundColor: "rgb(248, 249, 250)",
										textDecorationThickness: "initial",
										textDecorationStyle: "initial",
										textDecorationColor: "initial"
									} }),
									/* @__PURE__ */ _jsx("span", {
										style: {
											color: "rgb(15, 15, 15)",
											fontFamily: "Helvetica",
											fontSize: 30,
											fontStyle: "normal",
											fontVariantLigatures: "normal",
											fontVariantCaps: "normal",
											fontWeight: 400,
											letterSpacing: "normal",
											orphans: 2,
											textAlign: "left",
											textIndent: 0,
											textTransform: "none",
											widows: 2,
											wordSpacing: 0,
											WebkitTextStrokeWidth: 0,
											backgroundColor: "rgb(248, 249, 250)",
											textDecorationThickness: "initial",
											textDecorationStyle: "initial",
											textDecorationColor: "initial",
											float: "none",
											display: "inline !important"
										},
										children: "}"
									})
								]
							})
						})
					})
				}), /* @__PURE__ */ _jsx("text", {
					x: 314,
					y: 429,
					fill: "#0F0F0F",
					fontFamily: "Helvetica",
					fontSize: "30px",
					children: "{..."
				})] })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 540 370 L 791.54 277.38",
				fill: "none",
				stroke: "rgb(0, 0, 0)",
				strokeWidth: 4,
				strokeMiterlimit: 10,
				strokeDasharray: "12 12",
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 798.58 274.79 L 790.92 282.94 L 791.54 277.38 L 787.47 273.56 Z",
				fill: "rgb(0, 0, 0)",
				stroke: "rgb(0, 0, 0)",
				strokeWidth: 4,
				strokeMiterlimit: 10,
				pointerEvents: "all"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 180.16 339.95 L 262.58 269.29",
				fill: "none",
				stroke: "rgb(0, 0, 0)",
				strokeWidth: 4,
				strokeMiterlimit: 10,
				strokeDasharray: "12 12",
				pointerEvents: "stroke"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 268.28 264.41 L 263.94 274.72 L 262.58 269.29 L 257.43 267.12 Z",
				fill: "rgb(0, 0, 0)",
				stroke: "rgb(0, 0, 0)",
				strokeWidth: 4,
				strokeMiterlimit: 10,
				pointerEvents: "all"
			})
		] }),
		/* @__PURE__ */ _jsxs("switch", { children: [/* @__PURE__ */ _jsx("g", { requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility" }), /* @__PURE__ */ _jsx("a", {
			transform: "translate(0,-5)",
			xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
			target: "_blank",
			children: /* @__PURE__ */ _jsx("text", {
				textAnchor: "middle",
				fontSize: "10px",
				x: "50%",
				y: "100%",
				children: "Text is not SVG - cannot display"
			})
		})] })
	]
});
export default SvgStateContainer;
